import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=16b88fbc&"
import script from "./Options.vue?vue&type=script&lang=js&"
export * from "./Options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b88fbc')) {
      api.createRecord('16b88fbc', component.options)
    } else {
      api.reload('16b88fbc', component.options)
    }
    module.hot.accept("./Options.vue?vue&type=template&id=16b88fbc&", function () {
      api.rerender('16b88fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/emails/Options.vue"
export default component.exports